import { sendAuthorizedRequest, HttpMethod} from './authWrapper';
import { WhiteListNumbersEndpointBaseUrl} from '../properties/appProperties';

export function getWhiteListNumbers(host: string) {
    let whiteListNumbersEndpoint = host + WhiteListNumbersEndpointBaseUrl;
    return sendAuthorizedRequest(HttpMethod.GET, whiteListNumbersEndpoint);
  }